import { createContext } from 'react';

export interface TokenManagerContextValue {
  checkAndRefreshToken: () => Promise<void>;
}

export const TokenManagerContext = createContext<
  TokenManagerContextValue | undefined
>(undefined);
